export default "__VITE_ASSET__859dLDoj__"